import { LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutEdiDelayCodePartners } from "./autogen/AutogenLayoutEdiDelayCodePartners";
import { EdiPartnerQualifiersHelper } from "./EdiPartnerQualifiersBase";

export class EdiDelayCodePartners extends AutogenLayoutEdiDelayCodePartners {
    private _delayPartnerId: string;
    private _delayVersion: string;

    setPartnerValues(delayPartnerId: string, delayVersion: string) {
        this.delayPartnerId = delayPartnerId;
        this.delayVersion = delayVersion;
    }

    setColumnsForStatus() {
        const columnsToRemove = ["columnHeaderSendToDriver"];
        EdiPartnerQualifiersHelper.setColumnsForTender(this.tablePartnerQualifiers, columnsToRemove);
    }

    setEnabledButtonEnabledProperties(isEnabled: boolean) {
        EdiPartnerQualifiersHelper.setEnabledButtonEnabledProperties(this.buttonDisableAll, this.buttonEnableAll, isEnabled);
    }

    async disableButtonOnClick() {
        await EdiPartnerQualifiersHelper.setRecordsOnClick(
            this.tablePartnerQualifiers,
            this.mainDataSource,
            false,
            "Are you sure you want to disable all delay codes?",
            this.buttonDisableAll
        );
    }

    async enableButtonOnClick() {
        await EdiPartnerQualifiersHelper.setRecordsOnClick(
            this.tablePartnerQualifiers,
            this.mainDataSource,
            true,
            "Are you sure you want to enable all delay codes?",
            this.buttonEnableAll
        );
    }

    returnFormattedRows() {
        return EdiPartnerQualifiersHelper.returnFormattedRows(this.tablePartnerQualifiers);
    }

    beforeStandardCodeLookup(event: LookupModelSearchEvent) {
        EdiPartnerQualifiersHelper.setupLookupFilterDelay(event, this.delayPartnerId, this.delayVersion, true);
    }

    standardCodeOnLookupModelSearch(event: LookupModelSelectionEvent) {
        EdiPartnerQualifiersHelper.handleLookupSelection(event, this.delayPartnerId, this.delayVersion);
    }

    get delayPartnerId(): string {
        return this._delayPartnerId;
    }

    set delayPartnerId(value: string) {
        this._delayPartnerId = value;
    }

    get delayVersion(): string {
        return this._delayVersion;
    }

    set delayVersion(value: string) {
        this._delayVersion = value;
    }
}